function leftpad(str, len = 2, pad = "0") {
  str = str.toString();
  return (
    Array.apply(null, { length: len - str.length })
      .map(() => pad)
      .join("") + str
  );
}

export function formatDate(date) {
  if (!date) return null;

  date = new Date(date);

  return [
    leftpad(date.getDate()),
    leftpad(date.getMonth() + 1),
    date.getFullYear(),
  ].join(".");
}

export function formatTime(date) {
  if (!date) return null;

  date = new Date(date);

  return [leftpad(date.getHours()), leftpad(date.getMinutes())].join(":");
}
